import React, { useState } from "react";
import PreLoaderWidget from '../../../components/Loader';
import ImageView from '../../../gb-components/ImageView';
import './anexo.scss';

const ContAnexo = ({ anexos, preloadAnexos }) => {
  return (
    <>
      <div className="p-2">
        <h1>Arquivos Anexados</h1>
        <div className="gb-divider"><div className="line"></div></div>
        {preloadAnexos ? (<div className="text-center" style={{ textAlign: 'center' }}><center>
          <PreLoaderWidget ></PreLoaderWidget>
          carregando...
        </center></div>) : null}

        <ImageView midias={anexos} />

      </div>
    </>
  )
}

export default ContAnexo;